import * as React from 'react'
import Slide from '../Slide'
import i18n from '../../../../i18n'
import { i18nKeys } from 'translationTypes'
import { Interpolate } from '@doordash/lib-i18n'
import { Text } from '@doordash/design-language'
import { StyledUl } from './styles'
import { BASE_GROWTH_IMAGE_CDN } from '../../../../constants'

import { ReduxProps } from '../InAppEducationV4'
import { SlideProps } from './'

const ANIMATION_ENDPOINT = `${BASE_GROWTH_IMAGE_CDN}/in_app_education/iaev4_vip_dasher_support.json`

type Props = SlideProps & ReduxProps & React.ComponentPropsWithoutRef<'div'>

const GetSupport: React.FC<Props> = ({ index, ...props }) => (
  <Slide
    jsonUrl={ANIMATION_ENDPOINT}
    title={i18n.t(i18nKeys.inAppEducation__getSupport__title)}
    subtitle={i18n.t(i18nKeys.inAppEducation__getSupport__subtitle)}
    index={index}
    {...props}
  >
    <Text styles={Text.Styles.Body1} color={Text.Colors.TextSecondary}>
      {i18n.t(i18nKeys.inAppEducation__getSupport__content__line1)}
    </Text>
    <StyledUl>
      <li>
        <Text styles={Text.Styles.Body1} color={Text.Colors.TextSecondary}>
          <Interpolate
            i18n={i18n}
            i18nKey={i18nKeys.inAppEducation__getSupport__content__bullet1}
            components={[
              <Text
                weight={Text.Weights.Bold}
                display={Text.DisplayModes.Inline}
                color={Text.Colors.TextSecondary}
              />,
            ]}
          />
        </Text>
      </li>
      <li>
        <Text styles={Text.Styles.Body1} color={Text.Colors.TextSecondary}>
          <Interpolate
            i18n={i18n}
            i18nKey={i18nKeys.inAppEducation__getSupport__content__bullet2}
            components={[
              <Text
                weight={Text.Weights.Bold}
                display={Text.DisplayModes.Inline}
                color={Text.Colors.TextSecondary}
              />,
            ]}
          />
        </Text>
      </li>
    </StyledUl>
  </Slide>
)

export default GetSupport
